module.exports = __webpack_public_path__ + "img/merchant-home-lcpzs.ce3e36e2.png";